/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ListInboxChatsTab = typeof ListInboxChatsTab[keyof typeof ListInboxChatsTab];


export const ListInboxChatsTab = {
  inbox: 'inbox',
  sent: 'sent',
  cancelled: 'cancelled',
  scheduled: 'scheduled',
  interested: 'interested',
  not_interested: 'not_interested',
} as const;
